(() => {
  "use strict";

  const copy = {
    es: { title: "Celebridades", action: "Ver selección", models: "modelos disponibles" },
    en: { title: "Celebrities", action: "View selection", models: "available models" },
  };
  const attached = new WeakSet();

  const safePath = (handle, rootUrl) => {
    const base = String(rootUrl || "/").replace(/\/+$/, "");
    return `${base}/pages/celebridades/${encodeURIComponent(String(handle || ""))}`;
  };

  const element = (tag, className, text) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = String(text);
    return node;
  };

  const initials = (name) => String(name || "OH").split(/\s+/).filter(Boolean).slice(0, 2)
    .map((part) => part.charAt(0)).join("").toUpperCase();

  const render = (panel, items, locale, root) => {
    const labels = copy[locale];
    const list = panel.querySelector("[data-ohsc-list]");
    list.replaceChildren();
    for (const item of items.slice(0, 4)) {
      const li = element("li", "ohsc-card");
      const link = element("a", "ohsc-card__link");
      link.href = safePath(item.handle, root.dataset.rootUrl);
      link.dataset.ohscCelebrity = item.handle || "";
      const portrait = item.portrait_url;
      let portraitNode = null;
      if (portrait) {
        try {
          const url = new URL(portrait);
          if (url.protocol === "https:") {
            const image = element("img", "ohsc-card__portrait");
            image.src = url.href;
            image.alt = locale === "en" ? item.portrait_alt_en || "" : item.portrait_alt_es || "";
            image.loading = "lazy";
            image.decoding = "async";
            portraitNode = image;
          }
        } catch (_) {
          // Invalid remote images are intentionally omitted.
        }
      }
      if (!portraitNode) {
        portraitNode = element("span", "ohsc-card__portrait ohsc-card__initials", initials(item.name));
        portraitNode.setAttribute("aria-hidden", "true");
      }
      link.append(portraitNode);
      const body = element("span", "ohsc-card__body");
      body.append(element("strong", "ohsc-card__name", item.name || ""));
      body.append(element("span", "ohsc-card__meta", `${Number(item.available_models) || 0} ${labels.models}`));
      link.append(body, element("span", "ohsc-card__action", labels.action));
      li.append(link);
      list.append(li);
    }
    panel.hidden = list.childElementCount === 0;
  };

  const attach = (root) => {
    if (attached.has(root)) return;
    const input = root.querySelector("[data-ohs-query]");
    const region = root.querySelector(".ohs-results-region");
    if (!input || !region) return;
    attached.add(root);

    const locale = String(root.dataset.locale || "es").toLowerCase().startsWith("en") ? "en" : "es";
    const panel = element("section", "ohsc-panel");
    panel.hidden = true;
    panel.setAttribute("aria-labelledby", "ohsc-title");
    const header = element("div", "ohsc-panel__header");
    const title = element("h3", "ohsc-panel__title", copy[locale].title);
    title.id = "ohsc-title";
    header.append(title);
    const list = element("ul", "ohsc-list");
    list.dataset.ohscList = "";
    list.setAttribute("role", "list");
    panel.append(header, list);
    region.prepend(panel);

    let timer = 0;
    let controller = null;
    let sequence = 0;
    const search = async () => {
      const query = input.value.trim();
      if (query.length < 2) {
        controller?.abort();
        panel.hidden = true;
        list.replaceChildren();
        return;
      }
      controller?.abort();
      controller = new AbortController();
      const current = ++sequence;
      const endpoint = String(root.dataset.endpoint || "").replace(/\/+$/, "");
      if (!endpoint) return;
      const url = new URL(`${endpoint}/v1/celebrities`);
      url.searchParams.set("q", query);
      url.searchParams.set("per_page", "4");
      try {
        const response = await fetch(url.href, {
          mode: "cors",
          credentials: "omit",
          headers: { Accept: "application/json" },
          signal: controller.signal,
        });
        if (!response.ok) throw new Error(`celebrity-search-${response.status}`);
        const payload = await response.json();
        if (current !== sequence || input.value.trim() !== query) return;
        const items = Array.isArray(payload.items) ? payload.items : [];
        render(panel, items, locale, root);
        root.dispatchEvent(new CustomEvent("oh:celebrity-search", {
          bubbles: true,
          detail: { query, resultCount: Number(payload.found) || items.length },
        }));
      } catch (error) {
        if (error.name !== "AbortError") panel.hidden = true;
      }
    };

    input.addEventListener("input", () => {
      window.clearTimeout(timer);
      timer = window.setTimeout(search, 220);
    });
    panel.addEventListener("click", (event) => {
      const link = event.target.closest("[data-ohsc-celebrity]");
      if (!link) return;
      root.dispatchEvent(new CustomEvent("oh:celebrity-click", {
        bubbles: true,
        detail: { kind: "search_suggestion", celebrity: link.dataset.ohscCelebrity || "" },
      }));
    });
  };

  const scan = () => document.querySelectorAll("#oh-search-pilot").forEach(attach);
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", scan, { once: true });
  else scan();
  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
})();
